export function extrairParametros(url: string): { dados: string | null } {
    let queryString = "";

    if (url.includes("#")) {
        // Se a URL tem um hash, extrai a parte depois de "?"
        queryString = url.split("#")[1]?.split("?")[1] || "";
    } else {
        // Se não tem hash, usa a parte depois de "?"
        queryString = url.split("?")[1] || "";
    }

    const params = new URLSearchParams(queryString);
    return {
        dados: params.get("dados"),
    };
}